export const registerTokens = (state = [], action) => {
  if (action.type === "LOAD_REGISTERTOKENS") {
    return [...action.registerTokens]
  }
  if (action.type === "RESET") {
    return []
  }
  return state
}
